module.exports = __webpack_public_path__ + "static/media/tela-statix.ae1bc3d4.svg";